class ListingView {
  constructor() {
    this.listingViewSelector = document.querySelector(
      "listing-view-selector[data-listing-view]",
    );
    if (!this.listingViewSelector) return;

    this.listingViewButtons = Array.from(
      this.listingViewSelector.querySelectorAll(".listing-view-selector__button"),
    );
    this.allowedViews = ["grid", "list"];
    this.mobileImageSizes = {
      grid: "(min-width: 481px) calc(50vw - 1rem), calc(50vw - 0.5rem)",
      list: "(min-width: 481px) calc(100vw - 2rem), calc(100vw - 1rem)",
      compact: "(min-width: 481px) calc(33.333vw - 1.333rem), calc(33.333vw - 0.667rem)",
    };

    this.registerEvents();
  }

  registerEvents() {
    this.listingViewSelector.addEventListener("click", (event) => {
      const button = this.getViewButton(event.target);
      if (!button) return;

      const view = this.normalizeView(button.dataset.view);
      try {
        localStorage.setItem("listingView", view);
      } catch (error) {}

      this.applyView(view, { notify: true });
    });

    this.applyView();

    document.addEventListener("product-grid-updated", () => {
      this.applyView(this.getStoredView(), { notify: true });
    });
  }

  getViewButton(target) {
    let node = target;
    while (node && node !== this.listingViewSelector) {
      if (
        node.classList &&
        node.classList.contains("listing-view-selector__button") &&
        this.listingViewSelector.contains(node)
      ) {
        return node;
      }
      node = node.parentNode;
    }

    return null;
  }

  normalizeView(view) {
    return this.allowedViews.indexOf(view) > -1 ? view : "grid";
  }

  getStoredView() {
    try {
      return this.normalizeView(localStorage.getItem("listingView"));
    } catch (error) {
      return "grid";
    }
  }

  updateImageSizes(productGrid, view) {
    const mobileSizes = this.mobileImageSizes[view] || this.mobileImageSizes.grid;

    Array.prototype.forEach.call(productGrid.querySelectorAll("img[sizes]"), (img) => {
      const currentSizes = img.getAttribute("sizes") || "";
      const desktopSizes = currentSizes.indexOf("(min-width: 990px) 1px") > -1
        ? "(min-width: 990px) 1px"
        : "(min-width: 990px) calc((100vw - 6rem) / 4)";

      img.setAttribute("sizes", `${desktopSizes}, ${mobileSizes}`);
    });
  }

  applyView(view = this.getStoredView(), options = {}) {
    const currentView = this.normalizeView(view);
    const productGrid = document.querySelector("#product-grid");
    const previousView = productGrid ? productGrid.getAttribute("data-listing-view") : null;

    if (productGrid) {
      productGrid.setAttribute("data-listing-view", currentView);
      this.updateImageSizes(productGrid, currentView);
    }

    this.listingViewButtons.forEach((button) => {
      button.classList.toggle("is-active", button.dataset.view === currentView);
    });

    if (options.notify && productGrid && previousView !== currentView) {
      document.dispatchEvent(
        new CustomEvent("listing-view-changed", {
          detail: { view: currentView, previousView },
        }),
      );
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => new ListingView());
} else {
  new ListingView();
}
